<div id="nt-result" class="container">
  <div class="call-list-container">
    <h2 class="heading-underline with-icon">
      <div class="back-button" (click)="backToCallsList()">
        <i class="bhi-previous"></i>
        <span>Back to all calls</span>
      </div>
      <span id="call-title" class="truncate" matTooltip="{{call.description}} - {{bullhornCardContext.cardEntityName}}" matTooltipShowDelay="500">
        {{ call.description }} <span class="grey truncate">{{bullhornCardContext.cardEntityName}}</span>
      </span>
      <span class="call-info">
        <button mat-icon-button class="button-entity-icon"
          (click)="openPopup(); $event.stopPropagation()">
          <mat-icon class="material-icons-outlined">link</mat-icon>
          @if (linkedEntitiesCount > 0) {
            <span class="entity-count">{{linkedEntitiesCount}}</span>
          }
        </button>
        @if (showLinkedEntitiesPopup) {
          <app-linked-entities
            [bullhornCardContext]="bullhornCardContext"
            [currentCall]="call"
            (togglePopup)="onTogglePopup($event)">
          </app-linked-entities>
        }

        @if (call.duration !== zeroCallDuration) {
          <mat-icon fontIcon="timer" class="material-icons-outlined"></mat-icon>
        }
        @if (call.duration !== zeroCallDuration) {
          <span class="duration">{{ call.duration }}</span>
        }
        <mat-icon fontIcon="calendar_month" class="material-icons-outlined"></mat-icon>
        <span class="date-time">{{ call.date | date: 'medium' }}</span>
      </span>
    </h2>
  </div>
  <div class="result-content scrollable-container">
    <mat-accordion class="full-width-accordion">
      <mat-expansion-panel [disabled]="isSummaryDisabled"
        [matTooltip]="isSummaryDisabled ? 'Summary not available' : ''"
        matTooltipShowDelay="500">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon fontIcon="auto_awesome"></mat-icon>  AI generated summary of the call
            <mat-panel-description>
              @if (summaryValue) {
                <span class="truncate">{{ (summaryValue | slice:0:100) }}...</span>
              }
              <button theme="small"
                class="upload-button to-bullhorn"
                matTooltip="Save as Note"
                [disabled]="isLoading"
                (click)="saveSummaryButtonClick($event)">
                SAVE TO BULLHORN <i class="bhi-bull"></i><i class="bhi-bull"></i>
              </button>
            </mat-panel-description>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="summary" [ngClass]="{'active-tab': activeTab === 'Summary'}">
          <ul class="summary-container flex-table">
            @for (highlight of call.summary?.summary?.highlights; track highlight) {
              @if (highlight.title.toLowerCase() !== 'summary') {
                <li class="basic-flex-container">
                  <div class="highlight-content">
                    <p>{{highlight.title}}</p>
                    @if (!editingValue[highlight.title]) {
                      <span (mouseup)="selectOrEdit(highlight.title, $event, highlight.value)" class="summary-value"
                      matTooltip="Click to edit. Double click to copy" matTooltipShowDelay="500">{{highlight.value}}</span>
                    }
                    @if (editingValue[highlight.title] && highlight.value.length <= inputOrTextareaCharLimit) {
                      <input value="{{highlight.value}}"
                        (blur)="highlight.value = input.value; blurred(highlight.title)" (keydown.enter)="highlight.value = input.value; blurred(highlight.title)" #input>
                    }
                    @if (editingValue[highlight.title] && highlight.value.length > inputOrTextareaCharLimit) {
                      <textarea
                      (blur)="highlight.value = textarea.value; blurred(highlight.title)" #textarea>{{highlight.value}}</textarea>
                    }
                    <mat-icon fontIcon="content_copy" class="copy-icon" tabindex="0" matTooltip="Copy {{highlight.title}}"
                      (click)="copyToClipboard(highlight.value)"
                    (keydown.enter)="copyToClipboard(highlight.value)" (keydown.space)="copyToClipboard(highlight.title)"></mat-icon>
                    @if (!editingValue[highlight.title]) {
                      <mat-icon fontIcon="edit" class="edit-icon" tabindex="0" matTooltip="Amend {{highlight.title}}" matTooltipShowDelay="500" (click)="editValue(highlight.title)"></mat-icon>
                    }
                    @if (editingValue[highlight.title]) {
                      <mat-icon fontIcon="done" class="edit-icon" tabindex="0" matTooltip="Confirm changes" matTooltipShowDelay="500"></mat-icon>
                    }
                  </div>
                </li>
              }
            }
            @if (summaryValue) {
              <li class="summary basic-flex-container">
                <span>
                  <p>Summary</p>
                  <mat-icon fontIcon="content_copy" class="copy-icon" tabindex="0" matTooltip="Copy Summary"
                    (click)="copyToClipboard(summaryValue)"
                  (keydown.enter)="copyToClipboard(summaryValue)" (keydown.space)="copyToClipboard(summaryValue)"></mat-icon>
                  @if (!editingValue['Summary']) {
                    <mat-icon fontIcon="edit" class="edit-icon" tabindex="0" matTooltip="Amend Summary" matTooltipShowDelay="500" (click)="editValue('Summary')"></mat-icon>
                  }
                  @if (editingValue['Summary']) {
                    <mat-icon fontIcon="done" class="edit-icon" tabindex="0" matTooltip="Confirm changes" matTooltipShowDelay="500" (click)="blurred('Summary')"></mat-icon>
                  }
                </span>
                <!-- TODO: Doesn't need to be a pre - won't be HTML -->
                @if (!editingValue['Summary']) {
                  <pre [innerHTML]="summaryValue" class="scrollable-container"
                    matTooltip="Click to edit. Double click to copy" matTooltipShowDelay="500"
                  (mouseup)="selectOrEdit('Summary', $event, summaryValue)"></pre>
                }
                @if (editingValue['Summary']) {
                  <textarea
                    [(ngModel)]="summaryValue"
                  (blur)="blurred('Summary')" rows="4"></textarea>
                }
              </li>
            }
          </ul>

          <mat-accordion>
            <mat-expansion-panel class="notes-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <!-- TODO: Find a notes icon -->
                  <mat-icon fontIcon="edit"></mat-icon> Notes
                  <mat-panel-description>
                    @if (call.summary?.notes; as notes) {
                      <span class="truncate">
                        {{ notes.length > 100 ? (notes | slice: 0: 100) + '...' : notes }}
                      </span>
                    }


                    <!--<button theme="small" matTooltip="Save as Note" class="upload-button to-bullhorn">
                    SAVE TO BULLHORN <i class="bhi-bull"></i><i class="bhi-bull"></i>
                  </button>-->
                </mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="notes">
              <label>Notes</label>
              <textarea [(ngModel)]="notes"></textarea>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="isSummaryDisabled"
      [matTooltip]="isSummaryDisabled ? 'Answers not available' : ''"
      matTooltipShowDelay="500">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon fontIcon="question_answer"></mat-icon> Questions
          <mat-panel-description>
            <span></span>
            <button [disabled]="!hasDifferences || isLoading" theme="small" class="upload-button to-bullhorn" matTooltip="Save to Fields in Bullhorn" (click)="saveResult()">
              Save All Changes<i class="bhi-bull"></i><i class="bhi-bull"></i>
            </button>
          </mat-panel-description>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- TODO: GIVE THIS MORE TESTING -->
      @if ((call?.summaryPath) && (call?.summary?.QandAs)) {
        <table id="questions-container" class="table table-striped" [ngClass]="{'active-tab': activeTab === 'Questions'}">
          <!--        <table id="questions-container" class="table table-striped" [ngClass]="{'active-tab': activeTab === 'Questions'}">-->
          <tbody>
            <!--          <tr>-->
            <!--            <td><label for="question-pack">Question packs</label></td>-->
            <!--            <td>-->
            <!--              <mat-select id="question-pack" [(ngModel)]="selectedQuestionPack">-->
            <!--                <mat-option *ngFor="let pack of questionPacks" value="{{pack.id}}">{{ pack.description }}</mat-option>-->
          <!--              </mat-select>-->
        <!--            </td>-->
      <!--          </tr>-->
      @if ((call?.summaryPath) && (call.summary?.QandAs?.length ?? 0) > 0) {
        @for (QandA of call.summary?.QandAs; track QandA) {
          <tr class="question">
            <td [ngClass]="{'grey' : QandA.answer?.toLowerCase() === 'not found' }" class="highlight-content">
              {{QandA.question.question}}
              <br />
              <span class="bh-field-name">{{ QandA.fieldLabel }}</span>
            </td>
            <!-- add to td the ngif -->
            <td [ngClass]="{'grey' : QandA.answer?.toLowerCase() === 'not found' }" class="answer">
              @if (!editingValue[QandA.question.id]) {
                @if (QandA.answer?.toLowerCase() !== 'not found' && !questionMatches[QandA.question.id] && QandA.fieldLabel) {
                  <button theme="small-multiline" class="upload-button"
                    matTooltip="Save to Field" matTooltipShowDelay="500"
                    (click)="onSave(QandA)">
                    <mat-icon fontIcon="save" class="watermark"></mat-icon>
                    <mat-icon fontIcon="save"></mat-icon>
                    {{QandA.answer}}
                  </button>
                }
                @if (QandA.answer?.toLowerCase() === 'not found' || questionMatches[QandA.question.id] || !QandA.fieldLabel) {
                  <span class="summary-value"
                    matTooltip="Click to edit. Double click to copy" matTooltipShowDelay="500"
                    (mouseup)="selectOrEdit(QandA.question.id, $event, QandA.answer)">
                    {{QandA.answer}}
                  </span>
                }
              }
              @if (editingValue[QandA.question.id] && QandA.answer.length <= inputOrTextareaCharLimit) {
                <input [(ngModel)]="QandA.answer"
                  (blur)="blurred(QandA.question.id)" (input)="checkQuestionChange(QandA.question.id, QandA.answer)"
                  (keydown.enter)="blurred(QandA.question.id)" #input />
              }
              @if (editingValue[QandA.question.id] && QandA.answer.length > inputOrTextareaCharLimit) {
                <textarea
                  [(ngModel)]="QandA.answer" (input)="checkQuestionChange(QandA.question.id, QandA.answer)"
                (blur)="blurred(QandA.question.id)" rows="4" #textarea>{{ QandA.answer }}</textarea>
              }
              <mat-icon fontIcon="content_copy" class="copy-icon" tabindex="0" matTooltip="Copy answer"
                (click)="copyToClipboard(QandA.answer)"
              (keydown.enter)="copyToClipboard(QandA.answer)" (keydown.space)="copyToClipboard(QandA.answer)"></mat-icon>
              @if (!editingValue[QandA.question.id]) {
                <mat-icon fontIcon="edit" class="edit-icon" tabindex="0" matTooltip="Amend answer" matTooltipShowDelay="500" (click)="editValue(QandA.question.id)"></mat-icon>
              }
              @if (editingValue[QandA.question.id]) {
                <mat-icon fontIcon="done" class=" edit-icon" tabindex="0" matTooltip="Confirm changes" matTooltipShowDelay="500" (click)="blurred(QandA.question.id)"></mat-icon>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
}
</mat-expansion-panel>

<mat-expansion-panel [disabled]="!call.transcript"
  [matTooltip]="!call.transcript ? 'Generating transcript' : ''" matTooltipShowDelay="500" #transcriptPanel>
  <mat-expansion-panel-header class="tabs custom-header">
    <mat-panel-title>
      @if (call.summaryPath) {
        <mat-icon fontIcon="text_snippet"></mat-icon>
      }
      @if (!call.summaryPath) {
        <app-ai-stars-generating [generating]="!call.summaryPath"
        matTooltip="Generating transcript" matTooltipShowDelay="500"></app-ai-stars-generating>
      }
      Transcription
      <mat-panel-description>
        <span class="clear-input">
          <input class="transcript-search" type="text" [(ngModel)]="searchTerm" [disabled]="!call.summaryPath" (click)="handleSearchBoxPanel(transcriptPanel, $event)"
            (keydown.space)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" placeholder="Search..." #searchInput/>
            <i [ngClass]="searchInput.value ? 'bhi-times' : 'bhi-search'" class="clear-icon"
              (click)="clearInput(searchInput, true, $event)" (keydown.enter)="clearInput(searchInput, true)"
            [matTooltip]="searchInput.value ? 'Clear' : ''" matTooltipShowDelay="500" tabindex="0" #clearSearch></i>
          </span>
        </mat-panel-description>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <section class="transcript scrollable-container">
      <table class="transcription-table table table-striped-border-top-bottom">
        <tbody>
          @for (item of filteredTranscript(); track item) {
            <tr>
              @if (transcriptWithNames) {
                <td>{{item.name}} </td>
              }
              <td><mat-icon fontIcon="graphic_eq"></mat-icon></td>
              <td matTooltip="Double click to copy this line of the transcript" matTooltipShowDelay="500"
              (dblclick)="copyToClipboard(item.text)" [innerHTML]="item.text | highlight: searchTerm"></td>
              @if (item.time) {
                <td><mat-icon fontIcon="schedule"></mat-icon></td>
              }
              @if (item.time) {
                <td class="time-range" matTooltip="Double click to copy the time range" matTooltipShowDelay="500"
                (dblclick)="copyToClipboard(item.time)">{{ item.time }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </section>
    @if ((filteredTranscript() && filteredTranscript()!.length === 0 && searchInput.value !== '')) {
      <div class="no-results">
        <span>NO SEARCH RESULTS</span>
      </div>
    }
  </mat-expansion-panel>
</mat-accordion>
</div>
</div>
